import React from "react";
import { makeStyles } from "@material-ui/core"
import logo from "assets/logo-white.png";
import splash from "assets/splash.jpg";

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundImage: props => `url(${props.splash})`,
    height: "100vh",
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  intro: {
    flex: 1,
    maxWidth: "80%",
    textAlign: "center"
  },
  blurb: {
    textShadow: `4px 4px 5px ${theme.palette.blueGrey.dark}`,
    fontWeight: "bold",
    marginTop: theme.spacing(4),
    color: "#fff",
    fontSize: "38px",
    [theme.breakpoints.up("md")]: {
      fontSize: "48px"
    }
  },
  img: {
    maxWidth: "600px",
    width: "100%"
  }
}))

const Splash = () => {
  const classes = useStyles({ splash });
  return (
    <div className={classes.header}>
      <div className={classes.intro}>
        <img alt="Forever Snaps" className={classes.img} src={logo} />
        <div className={classes.blurb}>
          Open air photobooth hire for your next event in Sydney. 
        </div>
      </div>
    </div>
  )  
}

export default Splash;
